export default function Footer() {
  return (
    <footer data-testid="footer" className="relative overflow-hidden text-[#33181F] pt-24 pb-10" style={{ background: "linear-gradient(180deg, rgba(255,142,83,0.34), rgba(214,71,142,0.30))" }}>
      <div className="orb w-[420px] h-[420px] bg-[#FF8E53] blur-[140px] opacity-35 -top-32 left-1/4" aria-hidden="true" />

      <div className="wrap relative">
        <p className="eyebrow text-[#E8431F] mb-8">Studio de production wellness</p>
        <h2 className="font-display font-bold text-[clamp(2.6rem,9vw,7.5rem)] leading-[0.98] tracking-[-0.03em]">
          Douceur Power
          <span className="font-serifit italic font-normal text-[#B5502F]"> Prod</span>
        </h2>

        {/* Qui suis-je */}
        <div data-testid="qui-suis-je" className="mt-14 flex flex-col sm:flex-row items-start gap-8 md:gap-12">
          <div className="shrink-0">
            <img
              src="/images/alexia.webp"
              alt="Alexia Michel, fondatrice de Douceur Power Prod"
              data-testid="quisuisje-photo"
              className="w-40 h-40 md:w-48 md:h-48 object-cover object-center rounded-[24px] grayscale"
            />
          </div>
          <div>
            <p className="font-mono2 font-bold text-sm tracking-[0.18em] uppercase text-[#E8431F] mb-3">Qui suis-je ?</p>
            <p className="font-display font-semibold text-2xl md:text-3xl mb-5">Alexia Michel</p>
            <div className="flex flex-wrap gap-x-8 gap-y-3">
              <a
                href="https://www.douceurpower.com/qui-suis-je"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="quisuisje-link"
                className="font-mono2 text-sm text-[#33181F]/70 underline underline-offset-4 hover:text-[#E8431F] transition-colors"
              >
                Découvrir mon parcours
              </a>
              <a
                href="https://www.linkedin.com/in/alexia-michel/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="linkedin-link"
                className="font-mono2 text-sm text-[#33181F]/70 underline underline-offset-4 hover:text-[#E8431F] transition-colors"
              >
                LinkedIn
              </a>
            </div>
          </div>
        </div>

        {/* Logos pleine largeur, bande fondue dans la couleur exacte de la planche */}
        <div className="relative left-1/2 -translate-x-1/2 w-[100vw] mt-14" style={{ background: "#F7F3ED" }}>
          <div className="max-w-[820px] mx-auto py-8 md:py-10 px-6 md:px-14">
            <p className="font-mono2 text-[0.7rem] tracking-[0.16em] uppercase text-[#33181F]/50 mb-6">
              On a collaboré ou été vu par ici
            </p>
            <div className="relative">
              <img
                src="/images/logos-collab.webp"
                alt="RTL, Elle, BFM TV, Lululemon, Sciences Po, Bpifrance et autres partenaires"
                data-testid="logos-collab"
                className="w-full"
              />
              <img
                src="/images/les-bains.png"
                alt="Les Bains"
                data-testid="logo-les-bains"
                className="absolute w-[9%] right-[3%] bottom-[2%]"
              />
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#33181F]/15 flex flex-wrap items-center justify-between gap-6">
          <p className="eyebrow text-[#33181F]/50">Douceur Power Prod · 2026</p>
          <a
            href="mailto:alexia@ommymind.org"
            data-testid="footer-email"
            className="font-mono2 text-sm text-[#33181F]/70 hover:text-[#E8431F] transition-colors"
          >
            alexia@ommymind.org
          </a>
          <a
            href="tel:+33633341398"
            data-testid="footer-phone"
            className="font-mono2 text-sm text-[#33181F]/70 hover:text-[#E8431F] transition-colors"
          >
            06 33 34 13 98
          </a>
          <p className="eyebrow text-[#33181F]/50">douceurpower.com</p>
        </div>

        <p data-testid="footer-ommymind" className="mt-10 text-center font-serifit italic text-lg md:text-xl text-[#33181F]/70">
          Une agence portée par <span className="not-italic font-display font-semibold text-[#33181F]">Om My Mind</span> · Société à mission
        </p>
      </div>
    </footer>
  );
}
